(function () {
  if (window.__gscCards) return;
  window.__gscCards = true;
  function update(t) {
    var m = t.closest('.gsc__media');
    if (!m) return;
    var p = m.querySelector('.gsc__arr--prev'), n = m.querySelector('.gsc__arr--next');
    var max = t.scrollWidth - t.clientWidth - 2;
    if (p) p.hidden = t.scrollLeft <= 2;
    if (n) n.hidden = t.scrollLeft >= max;
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.gsc__arr');
    if (!b) return;
    e.preventDefault();
    var t = b.closest('.gsc__media').querySelector('.gsc__track');
    if (!t) return;
    var dir = b.classList.contains('gsc__arr--prev') ? -1 : 1;
    t.scrollBy({ left: dir * t.clientWidth, behavior: 'smooth' });
  });
  document.addEventListener('scroll', function (e) {
    var t = e.target;
    if (t && t.classList && t.classList.contains('gsc__track')) update(t);
  }, true);
})();